import { localizedText } from '../../common-js/LanguageMap';

export default function ($scope, $state, $log, $timeout, addonFactory, DrawpService) {
    $scope.localizedText = localizedText;
    const pageName = 'translate';
    $scope.clientAPIVersion = null;
    $scope.clientPlatform = null;

    const detectClientInfo = (info) => {
        if (info && info.platform) {
            $scope.clientPlatform = info.platform;
        }
        if (typeof Office !== 'undefined' && Office.context) {
            if (!$scope.clientPlatform) {
                $scope.clientPlatform = (Office.context.diagnostics && Office.context.diagnostics.platform) || Office.context.platform || null;
            }
            const knownVersions = ['1.10', '1.9', '1.8', '1.7', '1.6', '1.5', '1.4', '1.3', '1.2', '1.1'];
            if (Office.context.requirements && typeof Office.context.requirements.isSetSupported === 'function') {
                for (const ver of knownVersions) {
                    if (Office.context.requirements.isSetSupported('PowerPointApi', ver)) {
                        $scope.clientAPIVersion = ver;
                        break;
                    }
                }
            }
        }
    };

    if (typeof Office !== 'undefined' && Office.onReady) {
        Office.onReady(detectClientInfo);
    }
    detectClientInfo();


    $scope.stateTitle = $scope.localizedText('SLIDE_TRANSLATION');
    $scope.backState = 'addonAppIndex';
    $scope.stateClass = 'translate-item';

    $scope.progress = '';
    $scope.error = null;
    $scope.isPlaying = false;
    $scope.loginDialogMessage = '';
    $scope.isLoginDialogOpen = false;

    $scope.toolId = '6603b1a4e4b0f12b1a34567c';
    $scope.freeUsageLimitLeft = 0;
    $scope.freeUsageLimit = null;
    $scope.subscription = null;
    $scope.userEmail = localStorage.getItem('drawp-userEmail') || '';
    $scope.serverToken = localStorage.getItem('drawp-serverToken') || '';


    $scope.supportedSourceLanguage = [
        { 'val': 'all', 'text': 'Detect Language' },
        { 'val': 'AR', 'text': 'Arabic' },
        { 'val': 'BG', 'text': 'Bulgarian' },
        { 'val': 'CS', 'text': 'Czech' },
        { 'val': 'DA', 'text': 'Danish' },
        { 'val': 'DE', 'text': 'German' },
        { 'val': 'EL', 'text': 'Greek' },
        { 'val': 'EN', 'text': 'English' },
        { 'val': 'ES', 'text': 'Spanish' },
        { 'val': 'ET', 'text': 'Estonian' },
        { 'val': 'FA', 'text': 'Persian' },
        { 'val': 'FI', 'text': 'Finnish' },
        { 'val': 'FR', 'text': 'French' },
        { 'val': 'HU', 'text': 'Hungarian' },
        { 'val': 'ID', 'text': 'Indonesian' },
        { 'val': 'IT', 'text': 'Italian' },
        { 'val': 'JA', 'text': 'Japanese' },
        { 'val': 'KO', 'text': 'Korean' },
        { 'val': 'LT', 'text': 'Lithuanian' },
        { 'val': 'LV', 'text': 'Latvian' },
        { 'val': 'NB', 'text': 'Norwegian' },
        { 'val': 'NL', 'text': 'Dutch' },
        { 'val': 'PL', 'text': 'Polish' },
        { 'val': 'PT', 'text': 'Portuguese' },
        { 'val': 'RO', 'text': 'Romanian' },
        { 'val': 'RU', 'text': 'Russian' },
        { 'val': 'SK', 'text': 'Slovak' },
        { 'val': 'SL', 'text': 'Slovenian' },
        { 'val': 'SV', 'text': 'Swedish' },
        { 'val': 'TR', 'text': 'Turkish' },
        { 'val': 'UK', 'text': 'Ukrainian' },
        { 'val': 'ZH', 'text': 'Chinese' }
    ];

    $scope.supportedTargetLanguage = [
        { 'val': 'ES', 'text': 'Spanish', 'langCode': 'es-ES', 'blank': 'blanco' },
        { 'val': 'AR', 'text': 'Arabic', 'langCode': 'ar-001', 'blank': 'فارغ' },
        { 'val': 'BG', 'text': 'Bulgarian', 'langCode': 'bg-BG', 'blank': 'Празно' },
        { 'val': 'CS', 'text': 'Czech', 'langCode': 'cs-CZ', 'blank': 'prázdný' },
        { 'val': 'DA', 'text': 'Danish', 'langCode': 'da-DK', 'blank': 'blank' },
        { 'val': 'DE', 'text': 'German', 'langCode': 'de-DE', 'blank': 'leer' },
        { 'val': 'EL', 'text': 'Greek', 'langCode': 'el-GR', 'blank': 'κενό' },
        { 'val': 'EN', 'text': 'English', 'langCode': 'en', 'blank': 'blank' },
        { 'val': 'EN-GB', 'text': 'English (British)', 'langCode': 'en-GB', 'blank': 'blank' },
        { 'val': 'EN-US', 'text': 'English (American)', 'langCode': 'en-US', 'blank': 'blank' },
        { 'val': 'ET', 'text': 'Estonian', 'langCode': 'et-EE', 'blank': 'tühi' },
        { 'val': 'FA', 'text': 'Persian', 'langCode': 'fa-IR', 'blank': 'جای خالی' },
        { 'val': 'FI', 'text': 'Finnish', 'langCode': 'fi-FI', 'blank': 'tyhjä' },
        { 'val': 'FR', 'text': 'French', 'langCode': 'fr-FR', 'blank': 'vide' },
        { 'val': 'HU', 'text': 'Hungarian', 'langCode': 'hu-HU', 'blank': 'üres' },
        { 'val': 'ID', 'text': 'Indonesian', 'langCode': 'id-ID', 'blank': 'kosong' },
        { 'val': 'IT', 'text': 'Italian', 'langCode': 'it-IT', 'blank': 'vuoto' },
        { 'val': 'JA', 'text': 'Japanese', 'langCode': 'ja-JP', 'blank': '空白' },
        { 'val': 'KO', 'text': 'Korean', 'langCode': 'ko-KR', 'blank': '공백' },
        { 'val': 'LT', 'text': 'Lithuanian', 'langCode': 'lt-LT', 'blank': 'tuščias' },
        { 'val': 'LV', 'text': 'Latvian', 'langCode': 'lv-LV', 'blank': 'tukšs' },
        { 'val': 'NB', 'text': 'Norwegian', 'langCode': 'nb-NO', 'blank': 'blank' },
        { 'val': 'NL', 'text': 'Dutch', 'langCode': 'nl-NL', 'blank': 'blanco' },
        { 'val': 'PL', 'text': 'Polish', 'langCode': 'pl-PL', 'blank': 'pusty' },
        { 'val': 'PT', 'text': 'Portuguese', 'langCode': 'pt', 'blank': 'em branco' },
        { 'val': 'RO', 'text': 'Romanian', 'langCode': 'ro-RO', 'blank': 'gol' },
        { 'val': 'RU', 'text': 'Russian', 'langCode': 'ru-RU', 'blank': 'пустой' },
        { 'val': 'SK', 'text': 'Slovak', 'langCode': 'sk-SK', 'blank': 'prázdna' },
        { 'val': 'SL', 'text': 'Slovenian', 'langCode': 'sl-SI', 'blank': 'prazno' },
        { 'val': 'SV', 'text': 'Swedish', 'langCode': 'sv-SE', 'blank': 'tom' },
        { 'val': 'TR', 'text': 'Turkish', 'langCode': 'tr-TR', 'blank': 'boşluk' },
        { 'val': 'UK', 'text': 'Ukrainian', 'langCode': 'uk-UA', 'blank': 'порожній' },
        { 'val': 'ZH', 'text': 'Chinese', 'langCode': 'zh-CN', 'blank': '空白的' }
    ];

    $scope.translation = {
        'source_text': '',
        'source_language': 'all',
        'translated_language': 'ES',
        'translated_text': '',
        'slide_translated_language': 'ES'
    };

    $scope.slides = [];
    $scope.selectedSlides = [];
    $scope.anchorIndex = undefined;
    $scope.lastShiftRange = undefined;
    $scope.lastSelectedIndex = undefined;

    let elSlideLangSelect = null;
    let elSourceLangSelect = null;
    let elTargetLangSelect = null;
    let elSlideDialog = null;

    const showProgress = (show, message) => {
        $timeout(() => {
            $scope.progress = show ? message : '';
            if (show) $scope.error = null;
        });
    };

    const handleKeyDown = (event) => {
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const isCtrlOrCmd = isMac ? event.metaKey : event.ctrlKey;
        if (isCtrlOrCmd && event.keyCode === 65) { // 'A' key
            event.preventDefault();
            $scope.$apply(() => {
                $scope.selectAllSlides();
            });
        }
    };

    const openSlideDialog = () => {
        $timeout(() => {
            const dialogEl = document.querySelector('#slide-dialog');
            if (dialogEl) {
                if (!elSlideDialog) {
                    elSlideDialog = mdc.dialog.MDCDialog.attachTo(dialogEl);
                    elSlideDialog.listen('MDCDialog:closed', () => {
                        window.removeEventListener('keydown', handleKeyDown);
                    });
                }
                window.addEventListener('keydown', handleKeyDown);
                elSlideDialog.open();
            }
        }, 50);
    };

    $scope.clearSelection = () => {
        if ($scope.slides) {
            $scope.slides.forEach((slide) => {
                slide.isSelected = false;
            });
        }
        $scope.selectedSlides = [];
        $scope.lastSelectedIndex = undefined;
        $scope.anchorIndex = undefined;
        $scope.lastShiftRange = undefined;
    };

    $scope.selectAllSlides = () => {
        $scope.selectedSlides = [];
        if ($scope.slides) {
            $scope.slides.forEach((slide, index) => {
                slide.isSelected = true;
                $scope.selectedSlides.push(index);
            });
            if ($scope.slides.length > 0) {
                $scope.anchorIndex = 0;
                $scope.lastShiftRange = { start: 0, end: $scope.slides.length - 1 };
                $scope.lastSelectedIndex = $scope.slides.length - 1;
            }
        }
    };

    $scope.updateSelectedSlides = (index, isSelected) => {
        if (isSelected) {
            if (!$scope.selectedSlides.includes(index)) {
                $scope.selectedSlides.push(index);
            }
        } else {
            const idx = $scope.selectedSlides.indexOf(index);
            if (idx > -1) {
                $scope.selectedSlides.splice(idx, 1);
            }
        }
    };

    $scope.toggleCheckbox = (index, event) => {
        if (event) {
            event.preventDefault();
        }
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const isCmdOrCtrl = isMac ? event.metaKey : event.ctrlKey;
        const isShift = event.shiftKey;

        if (isShift && typeof $scope.anchorIndex !== 'undefined') {
            const start = Math.min($scope.anchorIndex, index);
            const end = Math.max($scope.anchorIndex, index);

            if ($scope.lastShiftRange) {
                for (let i = $scope.lastShiftRange.start; i <= $scope.lastShiftRange.end; i++) {
                    if (i < start || i > end) {
                        if ($scope.slides[i].isSelected) {
                            $scope.slides[i].isSelected = false;
                            $scope.updateSelectedSlides(i, false);
                        }
                    }
                }
            }

            for (let i = start; i <= end; i++) {
                const slideItem = $scope.slides[i];
                if (!slideItem.isSelected) {
                    slideItem.isSelected = true;
                    $scope.updateSelectedSlides(i, true);
                }
            }
            $scope.lastShiftRange = { start, end };
        } else if (isCmdOrCtrl) {
            const slideItem = $scope.slides[index];
            slideItem.isSelected = !slideItem.isSelected;
            $scope.updateSelectedSlides(index, slideItem.isSelected);

            if (!slideItem.isSelected) {
                $scope.anchorIndex = $scope.lastShiftRange ? $scope.lastShiftRange.end : $scope.anchorIndex;
            } else {
                $scope.anchorIndex = index;
            }
            $scope.lastShiftRange = undefined;
        } else {
            // Single select logic: deselect all others
            $scope.slides.forEach((slide, i) => {
                if (i !== index && slide.isSelected) {
                    slide.isSelected = false;
                    $scope.updateSelectedSlides(i, false);
                }
            });

            const slideItem = $scope.slides[index];
            slideItem.isSelected = true;
            $scope.updateSelectedSlides(index, true);

            $scope.anchorIndex = index;
            $scope.lastShiftRange = undefined;
        }
        $scope.lastSelectedIndex = index;
    };

    const initMDLSelects = () => {
        try {
            const slideLangSelectEl = document.querySelector('#slide-target-language');
            if (slideLangSelectEl) {
                elSlideLangSelect = mdc.select.MDCSelect.attachTo(slideLangSelectEl);
                elSlideLangSelect.listen('MDCSelect:change', () => {
                    $timeout(() => {
                        $scope.translation.slide_translated_language = elSlideLangSelect.value;
                    });
                });
            }

            const sourceLangSelectEl = document.querySelector('#source-language');
            if (sourceLangSelectEl) {
                elSourceLangSelect = mdc.select.MDCSelect.attachTo(sourceLangSelectEl);
                elSourceLangSelect.listen('MDCSelect:change', () => {
                    $timeout(() => {
                        $scope.translation.source_language = elSourceLangSelect.value;
                    });
                });
            }

            const targetLangSelectEl = document.querySelector('#target-language');
            if (targetLangSelectEl) {
                elTargetLangSelect = mdc.select.MDCSelect.attachTo(targetLangSelectEl);
                elTargetLangSelect.listen('MDCSelect:change', () => {
                    $timeout(() => {
                        $scope.translation.translated_language = elTargetLangSelect.value;
                    });
                });
            }
        } catch (e) {
            console.error("Error initializing select dropdowns:", e);
        }
    };

    $scope.onTranslateClick = async () => {
        if (!DrawpService.isLoggedIn()) {
            $scope.loginDialogMessage = 'Please login to use this tool.';
            $scope.isLoginDialogOpen = true;
            return;
        }

        if (isTranslationRunning) {
            console.log("[SlideTranslation] Previous translation task is still cleaning up. Waiting...");
            showProgress(true, 'Cleaning up previous operation...');
            let waitTime = 0;
            while (isTranslationRunning && waitTime < 5000) {
                await new Promise(r => setTimeout(r, 200));
                waitTime += 200;
            }
        }

        $scope.isTranslationCancelled = false;
        showProgress(true, 'Fetching presentation slides...');
        try {
            await PowerPoint.run(async (context) => {
                const slides = context.presentation.slides;
                slides.load("items");
                await context.sync();

                const list = [];
                for (let i = 0; i < slides.items.length; i++) {
                    list.push({
                        val: i,
                        text: `Slide ${i + 1}`,
                        isSelected: false
                    });
                }

                $timeout(() => {
                    $scope.slides = list;
                    $scope.clearSelection();
                    showProgress(false);
                    openSlideDialog();
                });
            });
        } catch (err) {
            console.error("Error fetching slides:", err);
            showProgress(false);
            $timeout(() => {
                $scope.error = "Could not fetch presentation slides.";
            });
        }
    };

    $scope.loadSubscriptionData = () => {
        $scope.userEmail = localStorage.getItem('drawp-userEmail') || '';
        $scope.serverToken = localStorage.getItem('drawp-serverToken') || '';

        if (!DrawpService.isLoggedIn()) {
            return;
        }

        DrawpService.getSubscriptionData($scope.toolId, $scope.serverToken)
            .then((response) => {
                const data = response && response.data ? response.data : null;
                if (data) {
                    const hasSub = (data.domain_enabled || (data.subscription_days_left != null && data.subscription_days_left > 0));
                    if (!hasSub) {
                        $scope.subscription = false;
                        $scope.freeUsageLimit = data.free_usage_limit;
                    } else {
                        $scope.subscription = true;
                    }
                    $scope.freeUsageLimitLeft = data.free_usage_limit_left != null ? data.free_usage_limit_left : 0;
                }
            })
            .catch((err) => {
                console.error("Failed to load subscription data for translate tool:", err);
            });
    };

    $scope.canSelectSlide = (selectedCount) => {
        if ($scope.subscription !== true && selectedCount > $scope.freeUsageLimitLeft) {
            $scope.launchSnackBar("You've reached your daily limit for 'Translation Tool'. Upgrade to a subscription to continue using all features without interruption.", 'Upgrade Now', true, () => { $scope.onPurchaseClick() });
            DrawpService.gABasicEvent('tool_limit_reached', {
                username: $scope.userEmail,
                pageName: 'translate',
                toolName: 'slide-translate',
                toolLimit: $scope.freeUsageLimit,
                toolId: $scope.toolId
            }, $scope.serverToken);

            return false;
        }
        return true;
    };

    $scope.onPurchaseClick = () => {
        if (!DrawpService.isLoggedIn()) {
            $scope.loginDialogMessage = 'Please login to purchase this tool.';
            $scope.isLoginDialogOpen = true;
        } else {
            DrawpService.gAPurchaseButtonSelectedEvent(15, $scope.translation ? $scope.translation.slide_translated_language : 'en', null, null, $scope.serverToken);
            $state.go('payment', {
                tool: "15",
                language: $scope.translation ? $scope.translation.slide_translated_language : 'en',
                data1: null,
                data2: null
            });
        }
    };

    $scope.isTranslationCancelled = false;
    $scope.isTranslating = false;
    let isTranslationRunning = false;
    let activePreloadedBase64 = null;

    $scope.cancelTranslation = () => {
        $scope.isTranslationCancelled = true;
        $scope.isTranslating = false;
        isTranslationRunning = false;
        // Instantly free heavy Base64 payload and active file handle from RAM on cancellation
        activePreloadedBase64 = null;
        if ($scope.clearSelection) {
            $scope.clearSelection();
        }
        if (DrawpService.closeActiveOfficeFile) {
            DrawpService.closeActiveOfficeFile();
        }
        showProgress(false);
        $timeout(() => {
            $scope.launchSnackBar('Translation cancelled.', 'Ok', true);
        });
    };

    $scope.translateSelectedSlides = async () => {
        const startTime = Date.now();
        if (isTranslationRunning || $scope.isTranslating) {
            console.warn("[SlideTranslation] Translation is already in progress.");
            return;
        }

        if ($scope.selectedSlides.length === 0) {
            $scope.launchSnackBar('Please select at least one slide to translate.', 'Ok', true);
            return;
        }

        if (!$scope.canSelectSlide($scope.selectedSlides.length)) {
            if (elSlideDialog) {
                elSlideDialog.close();
            }
            return;
        }

        // Lock state synchronously immediately on button click to prevent double invocation
        isTranslationRunning = true;
        $scope.isTranslating = true;

        if (elSlideDialog) {
            elSlideDialog.close();
        }

        const totalSelected = $scope.selectedSlides.length;

        if (!$scope.clientPlatform || !$scope.clientAPIVersion) {
            detectClientInfo();
        }

        DrawpService.gABasicEvent('select_slide_dialog_selection', {
            username: $scope.userEmail,
            pageName: 'translate',
            toolName: 'slide-translate',
            total_slides: $scope.slides.length,
            selected_slide: $scope.selectedSlides.toString(),
            api_version: $scope.clientAPIVersion,
            platform: $scope.clientPlatform

        }, $scope.serverToken);

        try {
            await DrawpService.toolUsageCount($scope.toolId, totalSelected, $scope.serverToken);
            $scope.freeUsageLimitLeft = Math.max(0, $scope.freeUsageLimitLeft - totalSelected);
        } catch (err) {
            if (err && (err.status === 402 || (err.data && err.data.status === 402))) {
                isTranslationRunning = false;
                $scope.isTranslating = false;
                $scope.launchSnackBar("You've reached your daily limit for 'Translation Tool'. Upgrade to a subscription to continue using all features without interruption.", 'Upgrade Now', true, () => { $scope.onPurchaseClick() });
                return;
            }
        }

        // Sort ascending (a - b) so we process slides from start to end (Slide 1, Slide 2, etc.)
        const sortedSelectedIndices = [...$scope.selectedSlides].sort((a, b) => a - b);
        const targetLang = $scope.translation.slide_translated_language;
        let successCount = 0;
        $scope.isTranslationCancelled = false;

        try {
            /**
             * PERFORMANCE & MEMORY OPTIMIZATION (SINGLE SLIDE EXPORT):
             * 1. Single Slide Export: Uses slide.exportAsBase64() (PowerPointApi 1.8) to export ONLY the target slide (~1MB payload instead of 270MB).
             * 2. Sequential Processing: Slides are processed one-by-one in index order.
             * 3. Per-Slide Yield Pause: Brief 100ms pause after every slide to unblock UI thread.
             */
            for (let k = 0; k < totalSelected; k++) {
                if ($scope.isTranslationCancelled) {
                    console.log("Translation process cancelled by user.");
                    break;
                }

                const originalSlideIdx = sortedSelectedIndices[k];
                // Since k slides have been inserted before this position, shift target index by k
                const currentTargetIdx = originalSlideIdx + k;

                showProgress(true, `Translating slide ${k + 1} of ${totalSelected}`);

                try {
                    const result = await DrawpService.replicateAndTranslateSlide(
                        currentTargetIdx,
                        targetLang,
                        null,
                        () => $scope.isTranslationCancelled
                    );
                    if (result === "Success") {
                        successCount++;
                    }
                } catch (err) {
                    console.error(`Translation failed on slide ${originalSlideIdx + 1}:`, err);
                    if (err && err.debugInfo) {
                        console.error("[SlideTranslation] Office.js Error Debug Info:", JSON.stringify(err.debugInfo, null, 2));
                    }
                    if ($scope.isTranslationCancelled) {
                        break;
                    }
                }

                // Per-slide microtask yield pause (100ms) to unblock UI thread
                await new Promise(r => setTimeout(r, 100));
            }
        } finally {
            isTranslationRunning = false;
            $scope.isTranslating = false;
            // Free any active file handles from RAM memory immediately after translation completes or cancels
            activePreloadedBase64 = null;
            if (DrawpService.closeActiveOfficeFile) {
                DrawpService.closeActiveOfficeFile();
            }
        }

        if (!$scope.isTranslationCancelled) {
            showProgress(false);
            $timeout(() => {
                if (successCount > 0) {
                    const msg = successCount === 1 ? '1 slide translated successfully!' : `${successCount} slides translated successfully!`;
                    $scope.launchSnackBar(msg, 'Ok', true);
                } else {
                    $scope.error = "Failed to translate selected slides.";
                }
            });

            DrawpService.gABasicEvent('translate_completed', {
                username: $scope.userEmail,
                pageName: 'translate',
                toolName: 'slide-translate',
                totalSlides: $scope.slides.length,
                totalSelectedSlides: $scope.selectedSlides.length,
                totalFailed: $scope.selectedSlides.length - successCount,
                totalTime: Math.round((Date.now() - startTime) / 1000) + "s",
            }, $scope.serverToken);
        }
    };

    $scope.translateText = async () => {
        if (!DrawpService.isLoggedIn()) {
            $scope.loginDialogMessage = 'Please login to use this tool.';
            $scope.isLoginDialogOpen = true;
            return;
        }

        if (!$scope.translation.source_text || $scope.translation.source_text.trim().length === 0) {
            $scope.launchSnackBar('Please enter source text to translate.', 'Ok', true);
            return;
        }

        showProgress(true, 'Translating text...');
        try {
            const result = await DrawpService.translateText($scope.translation.source_text, $scope.translation.translated_language, $scope.translation.source_language);
            $timeout(() => {
                $scope.translation.translated_text = result;
                showProgress(false);
                DrawpService.gABasicEvent('translate_completed', {
                    username: $scope.userEmail,
                    sourceText: $scope.translation.source_text,
                    sourceDetectedLanguage: $scope.translation.source_language,
                    translatedLanguage: $scope.translation.translated_language,
                    translatedText: $scope.translation.translated_text,
                    pageName: 'translate',
                    toolName: 'text-translate',
                });
            });
        } catch (err) {
            console.error("Text translation error:", err);
            showProgress(false);
            $timeout(() => {
                $scope.error = "Error during text translation.";
            });
        }
    };

    $scope.textToSpeech = (type) => {
        if (type === 'sourceText') {
            const sourceLang = $scope.translation.source_language || 'all';
            if (sourceLang === 'all') {
                $scope.convertTextToSpeech($scope.translation.source_text, 'EN');
            } else {
                $scope.convertTextToSpeech($scope.translation.source_text, sourceLang);
            }
        } else {
            $scope.convertTextToSpeech($scope.translation.translated_text, $scope.translation.translated_language);
        }
    };

    $scope.convertTextToSpeech = (conversionText, conversionLanguage) => {
        if (conversionText && conversionText.trim() !== '') {
            const selectedLangCode = $scope.supportedTargetLanguage.filter((node) => {
                return node.val === conversionLanguage.toUpperCase();
            });

            if (selectedLangCode.length > 0) {
                if ('speechSynthesis' in window && !$scope.isPlaying) {
                    try {
                        const synth = window.speechSynthesis;
                        const voices = synth.getVoices();
                        const processedText = conversionText.replace(/_+/g, selectedLangCode[0].blank);
                        const utterThis = new SpeechSynthesisUtterance(processedText);
                        const voice = voices.find(({ lang: _name }) => _name === selectedLangCode[0].langCode);

                        if (voice == null) {
                            $scope.textToSpeechUsingOpenAI(selectedLangCode, conversionText);
                        } else {
                            $scope.isPlaying = true;
                            utterThis.voice = voice;
                            utterThis.lang = selectedLangCode[0].langCode;

                            utterThis.onend = () => {
                                $timeout(() => {
                                    $scope.isPlaying = false;
                                });
                            };

                            utterThis.onerror = (event) => {
                                $timeout(() => {
                                    $scope.isPlaying = false;
                                });
                                console.error(`SpeechSynthesis error: ${event.error}`);
                            };

                            synth.speak(utterThis);
                        }
                    } catch (e) {
                        console.error(e);
                        $scope.textToSpeechUsingOpenAI(selectedLangCode, conversionText);
                    }
                } else {
                    $scope.textToSpeechUsingOpenAI(selectedLangCode, conversionText);
                }
            }
        }
    };

    $scope.textToSpeechUsingOpenAI = (selectedLangCode, conversionText) => {
        if (!$scope.isPlaying) {
            const processedText = encodeURIComponent(conversionText.replace(/_+/g, selectedLangCode[0].blank));
            const audioUrl = `${DrawpService.getServerUrl()}api/v2/google-addon/tts?q=${processedText}`;
            const audio = new Audio(audioUrl);
            audio.play();

            $scope.isPlaying = true;
            audio.onended = () => {
                $timeout(() => {
                    $scope.isPlaying = false;
                });
            };
        }
    };

    $scope.$on('ACCOUNT_CHANGE', () => {
        $scope.loadSubscriptionData();
    });

    angular.element(document).ready(() => {
        initMDLSelects();
        $scope.loadSubscriptionData();
        DrawpService.gAPageview(pageName, pageName, null, $scope.subscription, $scope.userEmail, $scope.serverToken);
    });
}
